import React from 'react'
import ExtendedReportLoan from './components/GeneralInformation/ExtendedReportLoan/ExtendedReportLoan';
import ExtendedReportTcp from './components/GeneralInformation/ExtendedReportTcp/ExtendedReportTcp';
import ExtendedReportIgr from './components/GeneralInformation/ExtendedReportIgr/ExtendedReportIgr';
import FinancialInfo from './components/FinancialInfo/FinancialInfo';
import PerformanceMonitoring from './components/PerformanceMonitoring/PerformanceMonitoring';
import ProjectMilestones from './components/ProjectMilestones/ProjectMilestones';
import EarlyWarnings from './components/EarlyWarnings/EarlyWarnings';
import Agreements from './components/Agreements/Agreements';
import EnviromentalSafeguards from './components/EnviromentalSafeguards/EnviromentalSafeguards';

type PreviewProps = {
    data: any;
    order: string[];
    isLoan?: boolean;
    isTcp?: boolean;
    isIgr?: boolean;
    creationDate?: any;
    regions?: any;
    myPortfolio?: string;
    countries?: string;
    filtersApplied?: any;
}


const DownloadPreviewPDF: React.FC<PreviewProps> = ({ data, order, isLoan, isTcp, isIgr, creationDate, regions, myPortfolio, countries, filtersApplied }) => {
    const componentsBySection: Record<string, () => JSX.Element | null> = {
        'loan-info': () =>
            data?.sectionOnePortfolio?.loan ? (
                <div className="pdf-page">
                    <ExtendedReportLoan
                        data={data.sectionOnePortfolio.loan}
                        creationDate={creationDate}
                        regions={regions}
                        myPortfolio={myPortfolio}
                        countries={countries}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'tcp-info': () =>
            data?.sectionOnePortfolio?.tcp ? (
                <div className="pdf-page">
                    <ExtendedReportTcp
                        data={data.sectionOnePortfolio.tcp}
                        creationDate={creationDate}
                        regions={regions}
                        myPortfolio={myPortfolio}
                        countries={countries}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'igr-info': () =>
            data?.sectionOnePortfolio?.igr ? (
                <div className="pdf-page">
                    <ExtendedReportIgr
                        data={data.sectionOnePortfolio.igr}
                        creationDate={creationDate}
                        regions={regions}
                        myPortfolio={myPortfolio}
                        countries={countries}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'financial-info': () =>
            data?.sectionTwoFinantialInformation ? (
                <div className="pdf-page">
                    <FinancialInfo
                        data={data.sectionTwoFinantialInformation}
                        isLoan={isLoan}
                        isTcp={isTcp}
                        isIgr={isIgr}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'performance-monitoring': () =>
            data?.sectionThreePerformanceMonitoring ? (
                <div className="pdf-page">
                    <PerformanceMonitoring
                        data={data.sectionThreePerformanceMonitoring}
                        isLoan={isLoan}
                        isTcp={isTcp}
                        isIgr={isIgr}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'project-milestones': () =>
            data?.sectionFourProjectLifeCycleMilestones ? (
                <div className="pdf-page">
                    <ProjectMilestones
                        data={data.sectionFourProjectLifeCycleMilestones}
                        isLoan={isLoan}
                        isTcp={isTcp}
                        isIgr={isIgr}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'early-warnings': () =>
            data?.sectionFiveEarlyWarningsGCMAlerts ? (
                <div className="pdf-page">
                    <EarlyWarnings
                        data={data.sectionFiveEarlyWarningsGCMAlerts}
                        isLoan={isLoan}
                        isTcp={isTcp}
                        isIgr={isIgr}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'agreements': () =>
            data?.sectionSixAccordances ? (
                <div className="pdf-page">
                    <Agreements
                        data={data.sectionSixAccordances}
                        isLoan={isLoan}
                        isTcp={isTcp}
                        isIgr={isIgr}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,

        'enviromental-safeguards': () =>
            data?.sectionSevenEnvironmentSocialSafe ? (
                <div className="pdf-page">
                    <EnviromentalSafeguards
                        data={data.sectionSevenEnvironmentSocialSafe}
                        isLoan={isLoan}
                        isTcp={isTcp}
                        isIgr={isIgr}
                        creationDate={creationDate}
                        regions={regions}
                        countries={countries}
                        myPortfolio={myPortfolio}
                        filtersApplied={filtersApplied}
                    />
                </div>
            ) : null,
    };

    return (
        <div>
            {order.map((sectionId, index) => {
                if (sectionId === 'general-info') {
                    return (
                        <React.Fragment key={`general-info-${index}`}>
                            {data?.isLoan && componentsBySection['loan-info']?.()}
                            {data?.isTcp && componentsBySection['tcp-info']?.()}
                            {data?.isIgr && componentsBySection['igr-info']?.()}
                        </React.Fragment>
                    );
                }

                const renderComponent = componentsBySection[sectionId];
                return renderComponent ? (
                    <div key={sectionId + index}>{renderComponent()}</div>
                ) : null;
            })}
        </div>
    );
}

export default DownloadPreviewPDF